import { Loader } from '@insify/design-system/components';
import clsx from 'clsx';

import styles from './WizardLoader.module.css';

const WizardLoader = ({ className, ...props }: React.ComponentProps<typeof Loader>) => (
  <Loader {...props} className={clsx(styles.loader, className)} />
);

export { WizardLoader };
